import { parsePathString } from '../parser/parse-path-string';
export function path2Array(pathInput) {
  return parsePathString(pathInput);
}